import { createReducer } from './utils'

const defaultState = {
    type: null,
    voucherName: '',
    voucherAmount: '',
    voucherText: '',
    participants: [{}],
    paymentOption: {},
    invoiceInfo: {
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        salutation: '',
        street: '',
        housenumber: '',
        zipCode: '',
        city: '',
        phone: ''
    },
    discount: {
        ref_id: '',
        voucher_code: '',
        voucher_amount: '',
        voucher_valide: '',
        type: ''
    }
}

export default createReducer({
    SHOP_STARTED: (state) => {
        return {
            ...state,
            type: 'training'
        }
    },

    ORDER_RESET: (state) => {
        return {
            ...state,
            ...defaultState
        }
    },

    'ORDER_INVOICE_INFO_CHANGED': (state, action) => {
        const invoiceInfo = {...state.invoiceInfo}
        invoiceInfo[action.name] = action.value

        return {
            ...state,
            invoiceInfo
        }
    },

    'ORDER_PAYMENT_OPTION_CHANGED': (state, action) => {
        return {
            ...state,
            paymentOption: action.paymentOption
        }
    },

    'ORDER_DISCOUNT_CHANGED': (state, action) => {
        return {
            ...state,
            discount: action.discount
        }
    },

    'ORDER_CHANGE_TRAINING': (state, action) => {
        const participants = state.participants.slice()
        while(participants.length < action.participantCount)
            participants.push({firstName: "", lastName: ""})

        return {
            ...state,
            trainingId: action.trainingId,
            participants
        }
    },

    'ORDER_PARTICIPANT_COUNT_CHANGED': (state, action) => {
        const participants = state.participants
            .slice(0, action.participantCount)

        while(participants.length < action.participantCount)
            participants.push({})

        return {
            ...state,
            participants
        }
    },
    'ORDER_PARTICIPANT_CHANGED': (state, action) => {
        const participants = state.participants.slice()

        participants[action.index][action.name] = action.value

        return {
            ...state,
            participants
        }
    },

    VOUCHER_UPDATE: (state, action) => {
        return {
            ...state,
            type: 'voucher',
            voucherName: action.name,
            voucherText: action.text,
            voucherAmount: action.amount,
        }
    },
}, defaultState)


// WEBPACK FOOTER //
// ./src/reducers/order.js